import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/index.css'

async function startApiMock(): Promise<void> {
  if (!import.meta.env.DEV || import.meta.env.VITE_ENABLE_API_MOCK !== 'true') return
  const { worker } = await import('./mocks/browser')
  await worker.start({ onUnhandledRequest: 'bypass' })
}

/**
 * 설치 조건을 채우는 서비스 워커를 세운다.
 *
 * 개발에서는 부르지 않는다. Mock 워커가 같은 자리를 쓰고 있어 둘이 부딪힌다.
 *
 * 등록이 실패해도 앱을 막지 않는다. 이 워커가 하는 일은 설치를 제안할 수 있게 만드는 것뿐이라
 * 서지 않아도 기록하고 읽는 일은 그대로 된다.
 */
function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}

const container = document.getElementById('root')
if (!container) throw new Error('root 엘리먼트를 찾지 못했다')

registerServiceWorker()

void startApiMock().then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
